import React, { ReactNode } from 'react';
import classNames from 'classnames';

type Props = {
  children: ReactNode;
  active?: boolean;
  disabled?: boolean;
} & ({ onClick: () => void; href?: never } | { onClick?: never; href: string });

function PillMenuItem({ children, href, active, disabled, onClick }: Props) {
  const styles = classNames(
    'z-10 px-3 md:px-5 h-10 md:h-12 rounded-3xl font-normal text-sm md:text-base flex items-center justify-center gap-2 md:gap-3 overflow-hidden whitespace-nowrap flex-shrink-0',
    active && 'bg-neutral-800 text-white hover:text-white font-bold',
    !active && 'text-neutral-600 hover:text-neutral-800',
    disabled && 'text-neutral-400 hover:text-neutral-400 cursor-not-allowed'
  );

  if (disabled) {
    return <div className={styles}>{children}</div>;
  }

  if (onClick) {
    return (
      <div onClick={onClick} className={styles} role="button" tabIndex={0}>
        {children}
      </div>
    );
  }

  return (
    <a href={href} className={styles}>
      {children}
    </a>
  );
}

export default PillMenuItem;
